<template>
 <bt-chart
      ref="chart"
      :options="optionsData"
      style="width:100%;height:100%"
      :autoresize="true"
      :init-options="{renderer:'svg'}"
  />
</template>

<script>
import drawCharts from '@/mixins/drawCharts.js'
import loading from '@/mixins/loading.js'
export default {
  mixins: [drawCharts, loading],
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isLegend:{
      type:Boolean,
      default:false,
    },
    seriesType: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    color:{
      type:Array,
      default:()=>[]
    },
    reverse:{
      type:Boolean,
      default:false,
    },
    styleMixs:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      labelBase: {
        label: {
          show: false,
          color: '#fff',
          fontSize: 12,
          position: 'top'
        }
      },
      grid: {
        top:'15%',
        left:10,
        right:20,
        bottom:10,        
        containLabel: true
      },
      AxisBase: {
        axisLine: {
          show: true,
          lineStyle:{
            color:'#fff'
          },
          symbol:['none','diamond']
        },
        axisTick: {
          show: false,
          interval: 0,
          // alignWithLabel: true
        },
        splitLine: {
          show: false,
          interval: 0
        }
      },
      styleBase: {
        itemStyle: {
          // color: '#7192e5',
          borderType: 'solid',
          borderWidth: 1,
          borderColor: '#000',
          barBorderRadius: [5, 5, 0, 0]
        },
        lineStyle: {
          // color: '#7192e5',
          borderType: 'solid',
          borderWidth: 4,
          width: 6,
          borderColor: '#000'
        },
      },
      legend:{},
      optionsData: {}
    }
  },
  watch: {
    list: {
      handler(val) {
        this.$nextTick(()=>{
          this.showLoading(this.$refs.chart)
          if (val && val.length > 0) {
              this.hideLoading(this.$refs.chart)
              this.legend = this.getLegend(this.isLegend,this.list)
              this.optionsData = this.getOptions()
          }
        })
      
      },
      immediate: true
    }
  },
  mounted() {
    // eslint-disable-next-line no-debugger
    // debugger
    this.styleBase = Object.assign(this.styleBase,this.styleMixs)
    this.grid.top = ( this.styleMixs && this.styleMixs.gridTop ? this.styleMixs.gridTop : '15%' )
    // eslint-disable-next-line no-debugger
    // this.labelBase.label.show = this.isShowLabel;
  },
  methods: {
    getOptions() {
      // console.log("series",this.getBarLineSeries(this.list, this.seriesType))
      return {
        title:{
          text:this.title,
          textStyle:{
              fontSize: 14,
              color: "#ABBEF1"
          },
          top:10,
          left:10
        },
        color:this.color,
        grid:this.grid,
        legend:{
          show:true,
          data:this.legend,
          icon: "rect",
          itemWidth: 20,
          itemHeight: 3,
          textStyle:{
            color:'#fff',
            fontSize:12
          },
          // top:10,
          // left:'center',
          padding:[15,0,0,30]
        },
        tooltip: {
          trigger: 'diamond',
          formatter: function(params) {
            if (typeof (params.value)[2] === 'undefined') {
              return params.name + ' : ' + params.value
            } else {
              return params.name + ' : ' + params.value[2]
            }
          }
        },
        xAxis:this.getXAxis(this.list,this.reverse),
        yAxis:this.getYAxis(this.list,this.reverse),
        series: this.getBarLineSeries(this.list, this.seriesType)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-container {
  width: 49%;
  height: auto;
}
</style>
